import { combineReducers } from 'redux'
import Agreement from './agreement-reducer'
import Filter from './filter-reducer'
import User from './user-reducer'
import Purpose from './purpose-reducer'
import Data from './data-reducer'

const combinedReducers = combineReducers({
  User,
  Agreement,
  Filter,
  Purpose,
  Data
})

export default combinedReducers



// WEBPACK FOOTER //
// ./src/redux-store/reducers/combinedReducer.js